module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "frontmatter_TOC-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "tocimage"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Dragon_.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('a', {
    attrs: {
      "href": "#/x13175_T2"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Chi and the Seven-Headed Dragon ")]), _vm._v(" "), _c('br'), _vm._v("Chinese legend "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage",
    staticStyle: {
      "margin-top": "0.4em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Inanna_Nishnibur_.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Inanna and the Box of Monsters")]), _vm._v(" "), _c('br'), _vm._v("Sumerian myth "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Red_Riding_Hood_type_girl.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("The Wolf in the Bed ")]), _vm._v(" "), _c('br'), _vm._v("French folktale "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Greek_Woman_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Telesilla and the Gates of Argos ")]), _vm._v(" "), _c('br'), _vm._v("Greek legend "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("35")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Ten_arms_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Durga and the Demon ")]), _vm._v(" "), _c('br'), _vm._v("Indian myth "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("40")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/young_man_as_sun.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Kopecho and the Two Suns ")]), _vm._v(" "), _c('br'), _vm._v("Venezuelan myth "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("46")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage",
    staticStyle: {
      "width": "1.5em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Girl_Carrying_Dish.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Mbango and the Whirlpool ")]), _vm._v(" "), _c('br'), _vm._v("Cameroonian folktale "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("52")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage",
    staticStyle: {
      "margin-top": "-0.2em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/viking_girl_.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Hervor and the Cursed Sword ")]), _vm._v(" "), _c('br'), _vm._v("Norse legend "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage",
    staticStyle: {
      "width": "1.3em",
      "margin-top": "-0.2em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Baba_Yaga_Hut_.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Visiting Baba Yaga ")]), _vm._v(" "), _c('br'), _vm._v("Russian folktale "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("68")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Honeysucklewoodbine.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Aliquipiso and the Cliffs")]), _c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }), _vm._v(" "), _c('br'), _vm._v("American Indian legend "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("78")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Girl_Swimming_.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("Tokoyo and the Skin Rope ")]), _vm._v(" "), _c('br'), _vm._v("Japanese legend "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("84")])])]), _vm._v(" "), _c('div', {
    staticClass: "tocimage"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Giant_dragging_girl_.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_TOC-chapter-head"
  }, [_c('span', {
    attrs: {
      "href": "#/x13175_T13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "frontmatter_TOC-chapter-number _idGenCharOverride-2"
  }, [_vm._v("The Giant’s Heart ")]), _vm._v(" "), _c('br'), _vm._v("Scottish folktale "), _c('span', {
    staticClass: "frontmatter_TOC-chapter-page-number"
  }, [_vm._v("95")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-302d0620","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/x13175_T1.vue
// module id = 63
// module chunks = 0